import {Theme} from '@lookiero/aurora';
import {StyleSheet, TextStyle, ViewStyle} from 'react-native';

const {space1, space2, space6} = Theme.get();

interface StyleFunctionResult {
  readonly footer: ViewStyle;
  readonly footerSmall: ViewStyle;
  readonly button: ViewStyle;
  readonly buttonDesktop: ViewStyle;
  readonly iconContainer: ViewStyle;
  readonly iconDesktop: ViewStyle;
  readonly text: TextStyle;
}

interface StyleFunction {
  (): StyleFunctionResult;
}

const style: StyleFunction = () =>
  StyleSheet.create<StyleFunctionResult>({
    footer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignContent: 'center',
      alignItems: 'flex-end',
      paddingHorizontal: 0,
      padding: 0,
    },
    footerSmall: {
      alignItems: 'center',
      paddingHorizontal: space2,
      paddingBottom: space1,
      paddingTop: space2,
      width: '100%',
    },
    button: {
      display: 'flex',
      flexDirection: 'column',
      alignSelf: 'auto',
      alignItems: 'center',
      justifyContent: 'center',
    },
    buttonDesktop: {
      flexDirection: 'row',
      marginLeft: space6,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      flex: 'auto',
      justifyContent: 'space-between',
    },
    iconContainer: {
      alignSelf: 'center',
      marginBottom: space1,
    },
    iconDesktop: {
      marginRight: space2,
      marginBottom: 0,
    },
    text: {
      overflow: 'hidden',
    },
  });

export {style};
